<template>
    <b-container id="about-us">
        <b-row class="content-section text-center">
            <b-col cols="12" class="content-area" v-animate-onscroll="'animated zoomIn'">
                <b-img-lazy v-bind="smallcontentProps" :src="content.content_image"
                    :alt="content.content_title"></b-img-lazy>
                <h2 :id="'header-section-' + content.content_id" v-html="content.content_title"></h2>
                <div :id="'content-section-' + content.content_id" v-html="content.content_description"></div>
                <div class="content-button">
                    <b-button :to="'/' + $store.state.selectlanguage + '/contact-us/submit'" class="btn-magenta">{{
                        $store.state.labels.LABEL_READY
                    }}</b-button>
                </div>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
export default {
    name: 'ContentBoxCompany',
    props: {
        content: { type: Object, required: true, default: null },
    },
    data() {
        return {
            smallcontentProps: {
                center: true,
                fluidGrow: false,
                blank: true,
                blankColor: "#bbb",
                class: "p-20",
            },
        }
    }
}
</script>

